import { api } from './_apiInterface';
import { localStorageHelper } from '../helpers/localStorageHelper';
import { millisecondsTwoMinutes } from '@monorepo/helpers';
import { pointer } from 'src/app-config';
import { typeWeatherAndForecast } from '@monorepo/models';

class WeatherServices {
    private Base = pointer.weather;
    //
    Get = async (): Promise<typeWeatherAndForecast | null> => {  // do not return typeResponseData
        try {
            const weatherInLS = localStorageHelper.GetWeatherAndForecast();
            if (weatherInLS) {
                const weatherInLSObj = JSON.parse(weatherInLS) as typeWeatherAndForecast;
                if (weatherInLSObj.date + millisecondsTwoMinutes > Date.now()) {
                    return {
                        date: weatherInLSObj.date,
                        forecast: weatherInLSObj.forecast,
                        weather: weatherInLSObj.weather
                    };
                }
            }
        } catch (error) {
            console.log(error);
        }
        const response = await api.SendRequest<{ weatherAndForecast: typeWeatherAndForecast; }>(this.Base, 'GET');
        if (!response.success || (!response.data?.weatherAndForecast?.weather && !response.data?.weatherAndForecast?.forecast)) {
            return null;
        }
        const weatherAndForecastString = JSON.stringify(response.data.weatherAndForecast);
        localStorageHelper.SetWeatherAndForecast(weatherAndForecastString);
        return response.data.weatherAndForecast;
    }
}

export const weatherServices = new WeatherServices();
